export enum QueryParamsEnum {
  LOGIN_HINT = 'login_hint',
  INDEX = 'index',
  POS = 'pos',
  SELLER = 'seller',
  CCK_NUMBER = 'cckNumber',
  CLIENT_NAME = 'clientName',
  SORT_PROPERTY = 'sortProperty',
  SORT_DIRECTION = 'sortDirection'
}

export type QueryParamsCallBack = {
  login_hint?: string;
  index?: string;
  pos?: string;
  seller?: string;
  cckNumber?: string;
  clientName?: string;
  sortProperty?: string;
  sortDirection?: string;
};

export type RedirectModel = {
  page: string;
  id?: string;
  subPage?: string;
  queryParams?: QueryParamsCallBack;
};

export type RedirectQueryParams = {
  token?: string;
  login_hint?: string;
};

export enum PageRoutingEnum {
  ROOT = '',
  HOME = 'home',
  ADMINISTRATION = 'administration',
  CALLBACK = 'callback',
  ERROR = 'error',
  SIMULATION = 'simulation',
  SUBSCRIPTION = 'subscription',
  RECORDS = 'records',
  LEADS = 'leads',
  PARAMETERS = 'parameters',
  ACTION_HUB = 'contract-action-hub'
}

export enum SubPageRoutingEnum {
  RESUME = 'resume',
  SIGNATURE = 'signature',
  DOCUMENTS = 'documents',
  MESSAGING = 'messaging',
  EXEMPTION_VR = 'exemptionvr',
  DELIVERY = 'delivery',
  HISTORY = 'filehistory'
}
